import dynamic from 'next/dynamic'

export const DynamicSpecialRequestModal = dynamic(
  () => import('.').then((mod) => mod.SpecialRequestModal),
  { ssr: false },
)
